import { AnyAction } from 'redux';

import { InstagramUserMediaObject } from 'apis/instagram';
import {
  RECEIVE_INSTAGRAM_MEDIA,
  REQUEST_INSTAGRAM_MEDIA
} from 'constants/reduxActions';

export interface InstagramReducer {
  media: InstagramUserMediaObject[];
  nextPageCursor?: string;
  loading: boolean;
  loaded: boolean;
}

const defaultState = {
  media: [],
  loading: false,
  loaded: false
};

const instagramReducer = (state: Readonly<InstagramReducer> = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_INSTAGRAM_MEDIA:
      return { ...state, loading: true };
    case RECEIVE_INSTAGRAM_MEDIA:
      const { media, nextPageCursor } = action;
      return { ...state, media: [...state.media, ...media], loaded: true, loading: false, nextPageCursor };
    default:
      return state;
  }
};

export default instagramReducer;
